import {Component, Input} from "@angular/core";
import {ILeaderboardRow} from "../../../../shared/interfaces/DTOs/Response/IGetExercisesLeaderboardRes";
import {DecimalPipe} from "@angular/common";

@Component({
  selector: "app-best-comparison",
  templateUrl: "./best-comparison.component.html",
  standalone: true,
  imports: [
    DecimalPipe
  ],
  styleUrls: ["./best-comparison.component.scss"]
})
export class BestComparisonComponent {
  @Input() leaderboardRow: ILeaderboardRow;

}
